const AFFILIATE_MEDIUM = "affiliate";
const REF_ID_PARAM_KEY = "refid";

/**
 * Returns the first non-empty RefID query value (case-insensitive key match)
 * only when `utm_medium=affiliate` is present.
 *
 * Accepts `window.location.search` (for example `?RefID=abc`) or a raw query
 * string.
 */
function getAffiliateRefIdFromSearchString(
  searchString: string,
): string | undefined {
  const params = new URLSearchParams(searchString.trim());

  if (
    !params.has("utm_medium") ||
    params.get("utm_medium") !== AFFILIATE_MEDIUM
  ) {
    return undefined;
  }

  for (const [key, value] of params.entries()) {
    if (key.toLowerCase() === REF_ID_PARAM_KEY) {
      const trimmed = value.trim();
      if (trimmed.length > 0) {
        return trimmed;
      }
    }
  }

  return undefined;
}

export { getAffiliateRefIdFromSearchString };
